import cloneDeep from "lodash/cloneDeep";
import * as api from "../../api/favouritesApi";
import type { FavouriteType } from "../../types/favouriteType";
const FavouritesListModel = {
  state: {
    isFavouriteListLoading: false,
    currentFavouritesCount: 0,
    favouriteList: [] as Array<any>,
  },
  reducers: {
    addFavourite(state: Record<string, any>, payload: FavouriteType): any {
      let favouriteList = cloneDeep(state.favouriteList);
      let favourite = { ...payload };
      favouriteList.push(favourite);
      return { ...state, favouriteList: favouriteList };
    },

    /**
     * looks up favouriteList with id equal to payload
     * and returns state without the favourite with given id
     */
    removeFavourite(state: Record<string, any>, payload: number): any {
      let favouriteList = cloneDeep(state.favouriteList);
      let validFavouriteList = favouriteList.filter(
        favourite => favourite.id !== payload
      );
      return { ...state, favouriteList: validFavouriteList };
    },

    /**
     * Update the whole list
     * payload: { favouriteList }
     */
    updateFavouriteList: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, favouriteList: payload.favouriteList };
    },

    /**
     * Set the current Bets count for the nav reports badge
     */
    setCurrentFavouritesCount: (
      state: Record<string, any>,
      payload: number
    ): any => {
      return { ...state, currentFavouritesCount: payload };
    },

    setFavouriteListRequest(state: Record<string, any>): any {
      return { ...state, isFavouriteListLoading: true };
    },

    /**
     * payload: { offset, competitionList }
     */
    setFavouriteListSuccess(
      state: Record<string, any>,
      payload: Record<string, any>
    ): any {
      return {
        ...state,
        favouriteList: payload.favouriteList,
        // currentFavouritesCount: payload.total,
        isFavouriteListLoading: false,
      };
    },

    /**
     * Empty the bet slip list
     */
    purgeFavouriteList: (state: Record<string, any>): any => {
      return { ...state, favouriteList: [] };
    },
  },
  effects: {
    /**
     * payload: { }
     */
    async setFavouriteList(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      this.setFavouriteListRequest();
      const options: Record<string, any> = {
        showMarketsGroupedByPeriodAndType: true,
        line: "",
      };

      if (payload && payload.line) {
        options.line = payload.line;
      }

      return api
        .getFavouriteList(options)
        .then((favouriteData: any) => {
          if (
            favouriteData !== undefined &&
            favouriteData.competitions !== undefined
          ) {
            this.setFavouriteListSuccess({
              favouriteList: favouriteData.competitions,
              total: favouriteData.total,
            });
          }

          if (payload && payload.callback) {
            payload.callback();
          }
        })
        .catch(error => {
          throw error;
        });
    },

    /**
     * payload: { }
     */
    async getFavouriteListCount(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      this.setFavouriteListRequest();
      return api
        .getCurrentFavouritesCount()
        .then((favouriteData: any) => {
          if (favouriteData !== undefined) {
            this.setCurrentFavouritesCount(favouriteData.total);
          }
        })
        .catch(error => {
          throw error;
        });
    },

    /**
     * payload: { }
     */
    async addFavouriteToList(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      this.setFavouriteListRequest();
      return api
        .addFavourite(payload.eventId)
        .then((favouriteData: any) => {
          if (favouriteData !== undefined) {
            // update favourites count
            this.getFavouriteListCount().then(() => {
              // get favourites
              this.setFavouriteList();

              if (payload.callback) {
                payload.callback(favouriteData);
              }
            });
          }
        })
        .catch(error => {
          throw error;
        });
    },

    /**
     * payload: { }
     */
    async removeFromFavouriteToList(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      this.setFavouriteListRequest();
      return api
        .removeFavourite(payload.eventId)
        .then((favouriteData: any) => {
          if (favouriteData !== undefined) {
            // update favourites count
            this.getFavouriteListCount().then(() => {
              // get favourites
              this.setFavouriteList();

              if (payload.callback) {
                payload.callback(favouriteData);
              }
            });
          }
        })
        .catch(error => {
          throw error;
        });
    },
  },
};
export default FavouritesListModel;
